'use client';

import { TotemCategorySidebar } from '@/app/(users)/totem-by-slug/[slug]/components/layout/totem-category-sidebar';
import { TotemHeader } from '@/app/(users)/totem-by-slug/[slug]/components/layout/totem-header';
import { TotemOrderOptionsOverlay } from '@/app/(users)/totem-by-slug/[slug]/components/layout/totem-order-options-overlay';
import { TotemOrderPanel } from '@/app/(users)/totem-by-slug/[slug]/components/layout/totem-order-panel';
import { TotemProductGrid } from '@/app/(users)/totem-by-slug/[slug]/components/layout/totem-product-grid';
import { TotemSearchPill } from '@/app/(users)/totem-by-slug/[slug]/components/layout/totem-search-pill';
import { useLocationPreference } from '@/app/(users)/totem-by-slug/[slug]/hooks/use-location-preference';
import { useTotem } from '@/app/(users)/totem-by-slug/[slug]/providers/totem-provider';
import { cn } from '@/lib/utils';

interface TotemShellProps {
  readOnly?: boolean;
}

export function TotemShell({ readOnly = false }: TotemShellProps) {
  const { cart, totem } = useTotem();
  const { data: locationPreference } = useLocationPreference(totem?.location_id ?? undefined);

  return (
    <div className={cn('flex h-dvh w-full flex-col overflow-hidden bg-background')}>
      <TotemHeader />
      {locationPreference?.totem_search && <TotemSearchPill />}
      <div className="relative flex min-h-0 flex-1">
        <div className="flex flex-col landscape:flex-row flex-1 min-w-0 min-h-0">
          <TotemCategorySidebar />
          <main className="flex min-h-0 min-w-0 flex-1 flex-col relative">
            <TotemProductGrid readOnly={readOnly} />
          </main>
        </div>
        {!readOnly && cart.items.length > 0 && <TotemOrderPanel />}
        {!readOnly && (locationPreference?.take_away || locationPreference?.eat_here) && <TotemOrderOptionsOverlay />}
      </div>
    </div>
  );
}
